/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from 'react';
import { 
  Button, 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter ,  
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardTitle,} from 'reactstrap';
  import DateTimePicker from "components/MaterialUI/DateTimePicker_treeMap.js";
  import CheckBoxList from "components/OthersCharts/CheckBoxList/multi-select-check.js"

const ModalExample = (props) => {
 

  return (
    <div>
    <Modal isOpen={props.open} toggle={props.handleClose} modalClassName={props.className}>
    <div className="modal-header">
      <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.handleClose}>
        <i className="tim-icons icon-simple-remove"></i>
      </button>
      <h5 className="modal-title">Filters</h5>
    </div>
    <ModalBody>
    <Col lg="12">
      <Card style={{backgroundColor:'transparent'}}>
        <CardHeader>
        <CardTitle tag="h4">
        </CardTitle>
        </CardHeader>
        <CardBody style={{marginTop:"-20px"}}>    
          <Row>
          <Col sm="12"> <DateTimePicker label = "Date: "  activeModeClass={props.activeModeClass} onChange={props.dateOnChange} value={props.dateValue}/> </Col>
          {/* <Col sm="6"> <DateTimePicker label = "To Date:"  activeModeClass={props.activeModeClass}/> </Col> */}
          </Row>
        </CardBody>
      </Card>
    </Col>        
    <Col lg="12" style={{marginTop:"-15px"}}>
      <Card style={{backgroundColor:'transparent'}}>
        <CardHeader>
        <CardTitle tag="h4">
        </CardTitle>
        </CardHeader>
        <CardBody style={{marginTop:"-15px"}}>
          <Row>
          <Col sm="12"> <CheckBoxList  level="A" onChange = {props.divAChange} value= {props.divAvalue} activeModeClass="dark-content" label="Select Department(s)"/> </Col> 
          </Row>             
        </CardBody>
      </Card>
    </Col>      
    </ModalBody>
    <ModalFooter>
    <Button color="warning" onClick={props.handleClose}>
      Close
    </Button>
    <Button color="warning" onClick={props.handleClose}>
      Save changes
    </Button>
    </ModalFooter>
    </Modal>
    </div>
  );
}

export default ModalExample;